import docs from './docs.png';
import drive from './drive.png';
import form from './form.png';
import forms from './forms.png';
import gmail from './gmail.png';
import notification from './notification.png';
import pdf from './pdf.png';
import sheets from './sheets.png';
import slides from './slides.png';
import twitter from './twitter.png';
import contacts from './contacts.png';
import photos from './photos.png';
import videos from './videos.png';
import clock from './clock.png';

export default {
  contacts,
  clock,
  videos,
  photos,
  docs,
  drive,
  form,
  forms,
  gmail,
  notification,
  pdf,
  sheets,
  slides,
  twitter,
};
